import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { IoSearchOutline } from "react-icons/io5";
import { HiOutlinePlus } from "react-icons/hi";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { TbRefresh } from "react-icons/tb";
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import API_URL from "../../src/Config";
import Pagination from "../Component/Pagination";

function IqcmFormList({ isSidebarExpanded }) {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);

  const [searchInput, setSearchInput] = useState("");
  const fetchTimeout = useRef(null);

  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState(null);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const popupRef = useRef(null);
  const navigate = useNavigate();

  const containerRef = useRef(null);
  const buttonRef = useRef(null);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  // fetch forms
  const fetchForms = async (currentPage, itemsPerPage, query = "") => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/qc/forms`, {
        headers: { Authorization: authKey },
        params: {
          page: currentPage,
          per_page: itemsPerPage,
          q: query,
        },
      });

      setForms(response.data.forms || []);
      setTotalItems(response.data.total || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching forms:", error.message);
      setLoading(false);
    }
  };

  // Debounce fetch when search input changes
  useEffect(() => {
    clearTimeout(fetchTimeout.current);

    fetchTimeout.current = setTimeout(() => {
      fetchForms(page, itemsPerPage, searchInput);
    }, 500);

    return () => clearTimeout(fetchTimeout.current);
  }, [searchInput, page, itemsPerPage]);

  const handlePaginationChange = (currentPage, perPage) => {
    setPage(currentPage);
    setItemsPerPage(perPage);
  };

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleRefresh = () => {
    setSearchInput("");
    fetchForms(page, itemsPerPage, "");
  };

  const handleSort = (column) => {
    const order =
      sortColumn === column && sortOrder === "asc" ? "desc" : "asc";

    setSortColumn(column);
    setSortOrder(order);

    const sorted = [...forms].sort((a, b) => {
      const aValue = a[column] ?? "";
      const bValue = b[column] ?? "";

      const isDate = !isNaN(Date.parse(aValue)) && !isNaN(Date.parse(bValue));
      if (isDate) {
        return order === "asc"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }

      if (!isNaN(Number(aValue)) && !isNaN(Number(bValue))) {
        return order === "asc" ? aValue - bValue : bValue - aValue;
      }

      const aFinal = aValue.toString().toLowerCase();
      const bFinal = bValue.toString().toLowerCase();
      if (aFinal < bFinal) return order === "asc" ? -1 : 1;
      if (aFinal > bFinal) return order === "asc" ? 1 : -1;
      return 0;
    });

    setForms(sorted);
    setIsSortPopup(false);
  };

  // const formatDates = (dateString) => {
  //   if (!dateString) return "NA";
  //   const date = new Date(dateString);
  //   return new Intl.DateTimeFormat("en-GB", {
  //     day: "2-digit",
  //     month: "2-digit",
  //     year: "numeric",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: true,
  //   }).format(date);
  // };

  const formatDates = (dateString) => {
  if (!dateString) return "NA";

  const date = new Date(dateString);

  let options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  // Format normally first
  let formatted = new Intl.DateTimeFormat("en-GB", options).format(date);

  // Force AM/PM to uppercase
  return formatted.replace(/am|pm/gi, (match) => match.toUpperCase());
};

  const handleButtonClick = (index) => {
    setSelectedRowIndex(index === selectedRowIndex ? null : index);
  };

  const handleViewClick = async (formId) => {
    console.log("id", formId)
    navigate(`/iqcmForm-view/${formId}`);
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          <div className="data-list-header">
            <div className="data-list-header-content">
              <PageBackTitle>QC INSPECTION</PageBackTitle>
              <div className="data-list-heading-content-right-side">
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchInput}
                    onChange={handleSearchInputChange}
                    className="search-bar"
                  />
                  <IoSearchOutline className="search-bar-icon" />
                </div>

                {/* <Link to="/add-new-iqcmForm" className="data-list-new">
                  <Tooltip title="New Form" arrow>
                    <button className="new-button">
                      <HiOutlinePlus className="new-plus-icon" /> New
                    </button>
                  </Tooltip>
                </Link> */}

                <Tooltip title="Refresh List" arrow>
                  <button className="refresh-button" onClick={handleRefresh}>
                    <TbRefresh className="refresh-icon" />
                  </button>
                </Tooltip>

                <button
                  className="sort-button"
                  onClick={() => setIsSortPopup(!isSortPopup)}
                  ref={buttonRef}
                >
                  <PiDotsThreeOutlineVerticalFill className="sort-icon" />
                </button>
                {isSortPopup && (
                  <div className="sort-popup-container" ref={containerRef}>
                    <div className="sort-popup-content">
                      <div className="sort-by">
                        SORT BY {sortOrder === "asc" ? "(Ascending)" : "(Descending)"}
                      </div>
                      <div className="sort-by-button">
                        <button onClick={() => handleSort("name")}>
                          Name{" "}
                          {sortColumn === "name" &&
                            (sortOrder === "asc" ? <MdExpandMore /> : <MdExpandLess />)}
                        </button>
                        <br />
                        <button onClick={() => handleSort("created_at")}>
                          Created At{" "}
                          {sortColumn === "created_at" &&
                            (sortOrder === "asc" ? <MdExpandMore /> : <MdExpandLess />)}
                        </button>
                        <br />
                        <button onClick={() => handleSort("last_inspected_on")}>
                          Last Inspected On{" "}
                          {sortColumn === "last_inspected_on" &&
                            (sortOrder === "asc" ? <MdExpandMore /> : <MdExpandLess />)}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="data-list-body">
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : forms.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="center-alignment">SR. NO.</th>
                        <th>NAME</th>
                        <th>CREATED AT</th>
                        <th>ITEMS COUNT</th>
                        <th>TOTAL ANSWERS</th>
                        {/* <th>CONTEXTS COUNT</th> */}
                        <th>LAST INSPECTED ON</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {forms.map((form, index) => (
                        <tr key={form.id} className="hoverable-row">
                          <td className="center-alignment">
                            {index + 1}
                          </td>
                          <td>{form.name || "NA"}</td>
                          <td>{formatDates(form.created_at)}</td>
                          <td>{form.items_count}</td>
                          <td>{form.total_answers}</td>
                          {/* <td>{form.contexts_count}</td> */}
                          <td>
                            {form.last_inspected_on
                              ? formatDates(form.last_inspected_on)
                              : "NA"}
                          </td>
                          <td className="edit-pop" style={{display:"flex"}}>
                              {/* <button
                                className="edit-data-button"
                                onClick={(event) => handleButtonClick(index,event)}
                              >
                                <div className="edit-button">
                                  <MdExpandMore />
                                </div>
                              </button> */}

                              <button
                                onClick={() => handleViewClick(form.id)}
                                className="button-bg"
                              >
                                View
                              </button>
                            </td>
                            {selectedRowIndex === index && (
                              <div className="edit-popup" ref={popupRef}>
                                <div className="edit-popup-contant">
                                  <div className="edit-popup-button">
                                    <Link
                                      to={`/edit-daily-progress/${form.id}`}
                                      className="inquiry-new"
                                    >
                                      <button className="edit-button-inquiry">
                                        <MdOutlineModeEditOutline /> Edit
                                      </button>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">No IQCM Forms Found</div>
                  </div>
                )}
              </div>
              <Pagination
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity="success">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default IqcmFormList;